<template>
    <div class="container">
        <subscription-info :subscription-active="subscriptionActive" :subscription="latestSubscriptionInfo" />

        <template v-if="isHasAnySubscription">
            <subscription-statistics :subscription-active="subscriptionActive" />
            <subscription-included :subscription-active="subscriptionActive" />
        </template>
        <template v-else>
            <subscribe-tree :show-header="false" id="tarifs"/>
        </template>

        <button
            class="sub-button sub-button--tertiary sub-button-cancel"
            @click="openSubscriptionWindow"
            v-if="subscriptionActive && subscription.canceled_at === null"
        >
            {{ $lang('subscriptionCancel.cancel') }}
        </button>

        <subscription-window
            :dialog-visible="subscriptionWindowVisible"
            @close="closeSubscriptionWindow"
            @change="chageSubscription"
        />

        <successful-unsubscribe
            :visible="unsubscribeWindowVisible"
            :subscription="latestSubscription"
            @close="closeUnsubscribeWindow"
        />

        <subscription-waiting v-if="isRequiredWaiting" />
    </div>
</template>

<script>
import SubscriptionInfo from "./SubscriptionInfo.vue";
import SubscriptionStatistics from "./SubscriptionStatistics.vue";
import SubscriptionIncluded from "./SubscriptionIncluded.vue";
import SubscribeTree from "../../vue/SubscribeTree.vue";
import SubscriptionWindow from "./SubscriptionWindow.vue";
import SuccessfulUnsubscribe from "./SuccessfulUnsubscribe.vue";
import SubscriptionWaiting from "./SubscriptionWaiting.vue";
import { mapGetters, mapActions } from 'vuex';
import { reachGoalOplatit } from '../../utils/yandex-metrica';

export default {
    name: 'Subscription',
    props: {
        paymentSuccess: {
            type: String,
            default: null
        }
    },
    components: {
        SubscriptionInfo,
        SubscriptionStatistics,
        SubscriptionIncluded,
        SubscribeTree,
        SubscriptionWindow,
        SuccessfulUnsubscribe,
        SubscriptionWaiting
    },
    data() {
        return {
            subscription: window.laravel.subscription,
            latestSubscription: window.laravel.latestSubscription,
            laravelData: window.laravel
        }
    },
    computed: {
        ...mapGetters('subscription', [
            'subscriptionWindowVisible',
            'unsubscribeWindowVisible'
        ]),
        subscriptionActive() {
            if (!this.subscription) {
                return false;
            }

            const now = new Date();
            const endDate = new Date(this.subscription.finished_at);

            return now < endDate;
        },
        isHasAnySubscription() {
            if(this.latestSubscription === null){
                return false;
            }

            if (!this.subscriptionActive) {
                return false;
            }

            return this.latestSubscription.payment_id !== null;
        },
        latestSubscriptionInfo(){
            const subscription = this.laravelData.latestSubscription;

            if(subscription === null){
                return null;
            }

            if(subscription.payment_id === null){
                return null;
            }

            return subscription;
        },
        isRequiredWaiting() {
            if (this.subscription !== null) {
                return false;
            }

            if (sessionStorage.getItem("isWaitingClosed") === "1") {
                return false;
            }

            return window.laravel.processing_subscription != 0;
        }
    },
    mounted() {
        if (this.paymentSuccess) {
            reachGoalOplatit("subscription payment success");
        }
    },
    methods: {
        ...mapActions('subscription', [
            'openSubscriptionWindow',
            'closeSubscriptionWindow',
            'closeUnsubscribeWindow',
        ]),
        chageSubscription(subscription, latestSubscription) {
            this.laravelData.latestSubscription = latestSubscription;
            this.latestSubscription = latestSubscription;
            this.subscription = subscription;
        }
    }
}
</script>
